import React from 'react';

import { QuestionCheckboxDefaultProps, QuestionCheckboxPropTypes } from 'src/components/JobDatasheet/propTypes';
import { EiqCheckbox } from 'eiq-storybook'

export const QuestionCheckbox = ({
  errors,
  flash,
  inTable,
  question,
  isRectifiedQuestion,
  label,
  onChange,
  value,
  disableChange,
}) => {
  const selectedValueKey = isRectifiedQuestion ? 'rectifiedValue' : 'value';

  const getReturnObject = val => {
    const returnObject = {
      ...value,
      type: 'checkbox'
    };

    returnObject[selectedValueKey] = val;

    return returnObject;
  };

  return (
    <EiqCheckbox
      checked={(value || { value: false })[selectedValueKey] || false}
      type='checkbox'
      ariaLabel='Checkbox'
      errorMessage={!!(errors || []).join(' & ')}
      id={question && question.id?`question-checkbox-${question.id}`:`question-checkbox`}
      inTable={inTable}
      label={label}
      sizeClass='checkbox--md'
      onChange={!disableChange && ((e) => onChange(getReturnObject(e.target.checked)))}
      value={(value || { value: false })[selectedValueKey] || false}
    />
  );
};

QuestionCheckbox.propTypes = QuestionCheckboxPropTypes;
QuestionCheckbox.defaultProps = QuestionCheckboxDefaultProps;
